import { cn } from "@/lib/utils";
import Image from "next/image";

interface ChipCardProps {
  id: string | number;
  icon?: string;
  alt_icon?: string;
  title?: string;
  description?: string;
  title_color?: string;
  description_color?: string;
}
const ChipCard = ({
  icon,
  alt_icon,
  title,
  description,
  title_color,
  description_color,
}: ChipCardProps) => {
  return (
    <div
      className={cn(
        "flex flex-col",
        "sm:w-[220px] sm:gap-[6px]",
        "md:w-[310px]",
        "lg:w-[310px]",
        "xl:w-[408px]",
      )}
    >
      <div
        className={cn(
          "flex items-center justify-center sm:justify-start",
          "xs:gap-3",
          "sm:gap-3",
        )}
      >
        {icon && (
          <div className={cn("relative", "xs:size-[20px]", "sm:size-6")}>
            <Image
              src={icon}
              alt={alt_icon || title || "Icon"}
              fill
              className="object-cover"
            />
          </div>
        )}
        {title && (
          <div
            className={cn(
              "xs:text-heading-8-semibold",
              "sm:text-heading-9-semibold",
              "md:text-heading-8-semibold",
              "lg:text-heading-7-semibold",
              "xl:text-heading-6-semibold",
              "type-h6",
            )}
            style={{
              color: title_color || "#000000",
            }}
          >
            {title}
          </div>
        )}
      </div>
      <hr className="border-gray-300 my-2" />
      {description && (
        <div
          className={cn(
            "xs:text-heading-9-regular",
            "sm:text-heading-9-regular",
            "md:text-heading-8-regular",
            "lg:text-heading-7-regular",
            "xl:text-heading-6-regular",
            "type-body-sm",
          )}
          style={{
            color: description_color || "#666666",
          }}
        >
          {description}
        </div>
      )}
    </div>
  );
};

export default ChipCard;
